module.exports = __webpack_public_path__ + "img/glacialcavern.c00130df.png";